import { memo, useMemo } from "react";

import { BillingTypeTarget } from "@/lib/gql/__generated__/graphql";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";

import { QuestionDayTripCoSleeping } from "./co-sleeping";
import { QuestionDayTripPlanDoNotCountKidsAsStock } from "./do-not-count-kids-as-stock";
import { QuestionDayTripPlanKidsPolicy } from "./kids-policy";
import { useProductDayTripPlanFormModelContext } from "../../../context";

const id = "question_plan_kidsPolicy";

export const QuestionPlanKidsPolicyRoot = memo(() => {
	const {
		viewModel: { billingTypeTarget, kidsPolicy, coSleepingKidsPrice, doNotCountKidsAsStock },
	} = useProductDayTripPlanFormModelContext();

	const canShow = useMemo(() => billingTypeTarget.value === BillingTypeTarget.Person, [billingTypeTarget]);

	const defaultValue = useMemo(() => {
		if (
			billingTypeTarget.isEdited ||
			kidsPolicy?.isEdited ||
			coSleepingKidsPrice?.amount.isEdited ||
			doNotCountKidsAsStock?.isEdited
		) {
			return id;
		}

		return undefined;
	}, [
		billingTypeTarget.isEdited,
		coSleepingKidsPrice?.amount.isEdited,
		doNotCountKidsAsStock?.isEdited,
		kidsPolicy?.isEdited,
	]);

	return (
		canShow && (
			<Accordion type={"single"} collapsible defaultValue={defaultValue}>
				<AccordionItem value={id}>
					<AccordionTrigger>
						<p>日帰りプラン独自のキッズポリシー設定</p>
					</AccordionTrigger>
					<AccordionContent>
						<div className="flex min-h-fit flex-col gap-y-12">
							<QuestionDayTripPlanKidsPolicy />
							<QuestionDayTripCoSleeping />
							<QuestionDayTripPlanDoNotCountKidsAsStock />
						</div>
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		)
	);
});

QuestionPlanKidsPolicyRoot.displayName = "QuestionPlanKidsPolicyRoot";
